/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

export const validationSchema = Yup.object({
  daysToRetain: Yup.string()
    .test('day to retain', 'not_valid', value => !/^\d*\.{1}\d*$/.test(value) && value > 0 && value <= 60)
    .required('required'),
});
